'use strict';

import User from './user';
import Collection from './collection';

export default class UserCollection extends Collection {
  constructor() {
    super(User);
  }
}
